import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { clearMessageById } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import EditEmailModal from "./Modal/EditEmail/editEmail.container";
import EditPasswordModal from "./Modal/EditPassword/editPassword.container";

const ProfileCredentials = () => {
    const { t } = useGranite();
    const [isEmailModalOpen, setEmailModalOpen] = useState(false);
    const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
    const customer = useSelector(CustomerSelectors.getCustomer);

    useEffect(() => {
        return function cleanUp() {
            setEmailModalOpen(false);
            setPasswordModalOpen(false);
        };
    }, []);

    if (!customer) {
        return null;
    }

    return (
        <>
            <div>
                <div className={cn("tw:mb-4")}>
                    <Row>
                        <Col
                            xs={6}
                            md={3}
                        >
                            <p>{t("profileCredentials.label.email")}</p>
                        </Col>
                        <Col>
                            <p>{`${customer.email}`}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className={cn("tw:pl-0")}
                                color={"link"}
                                type={"button"}
                                onClick={() => {
                                    clearMessageById("edit-email-success");
                                    setEmailModalOpen(true);
                                }}
                            >
                                <i
                                    className={cn(
                                        "las la-pencil-alt",
                                        "tw:mr-2"
                                    )}
                                />
                                {t("profileCredentials.link.changeEmail")}
                            </Button>
                        </Col>
                    </Row>
                </div>
                <div className={cn("tw:mb-4")}>
                    <Row>
                        <Col
                            xs={6}
                            md={3}
                        >
                            <p>{t("profileCredentials.label.password")}</p>
                        </Col>
                        <Col>
                            <p>●●●●●●●●</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                className={cn("tw:pl-0")}
                                color={"link"}
                                type={"button"}
                                onClick={() => setPasswordModalOpen(true)}
                            >
                                <i
                                    className={cn(
                                        "las la-pencil-alt",
                                        "tw:mr-2"
                                    )}
                                />
                                {t("profileCredentials.link.changePassword")}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </div>
            <EditPasswordModal
                isOpen={isPasswordModalOpen}
                onClose={() => setPasswordModalOpen(false)}
            />
            <EditEmailModal
                isOpen={isEmailModalOpen}
                onClose={() => setEmailModalOpen(false)}
            />
        </>
    );
};

export default ProfileCredentials;
